<template>
  <div>
    <spinner-round :isLoading="loading" v-if="loading"></spinner-round>
    <div v-if="user && !loading">
      <sticky class="page-header sticky-page-header page-header--new" :back-button="true">
        <div slot="left">
          <h1 class="title is-3">
            <router-link v-if="isAdmin || isManager || isSectorManager" :to="{name: 'UserList'}"
                         class="has-text-black is-uppercase">Utilisateurs /
            </router-link>
            <router-link v-if="user.companfy && (isAdmin || isSectorManager || (isExternal && isManager))"
                         :to="{name: 'CompanyVue', params: {id: user.company.pk}}"
                         class="has-text-weight-light has-text-black is-uppercase">
              {{user.company_name}}
            </router-link>
            <span v-else-if="user.company">{{user.company_name}}</span>
            <strong class="has-text-weight-medium has-text-grey is-uppercase">{{user.first_name}}
              {{user.last_name}}</strong>
          </h1>
        </div>
        <router-link :to="{name: 'UserEdit', params: {id: user.pk}}" class="dropdown-item" slot="dropdown-content"
                     v-if="isAdmin || isSectorManager || isManager || isMe">
          <span class="icon"><i class="fas fa-user-edit"></i></span>
          <span v-if="routeMe">Modifier mes informations</span>
          <span v-else> Modifier fiche</span>
        </router-link>
        <a id="invite-link" class="dropdown-item" slot="dropdown-content"
           v-if="(isAdmin || isSectorManager || isManager) && user.pk !== currentUserPk" @click.prevent.stop="inviteUser(user.email)">
          <span class="icon"><i class="fas fa-paper-plane"></i></span>
          <span>Envoyer invitation</span>
        </a>
        <a @click="manageNotifications" class="dropdown-item" slot="dropdown-content" v-if="routeMe">
          <span class="icon"><i class="fas fa-bell"></i></span>
          <span>Gérer les notifications</span>
        </a>
        <router-link :to="{name: 'ChangePassword', params: {id: user.pk}}" class="dropdown-item" slot="dropdown-content"
                     v-if="routeMe">
          <span class="icon"><i class="fas fa-unlock"></i></span>
          <span>Modifier mot de passe</span>
        </router-link>
        <a class="dropdown-item" slot="dropdown-content"
           v-if="(isAdmin || isSectorManager) && user.pk !== currentUserPk && !user.disabled" @click.prevent.stop="disableUser">
          <span class="icon"><i class="fas fa-minus-circle"></i></span>
          <span>Désactiver utilisateur</span>
        </a>
        <a class="dropdown-item" slot="dropdown-content"
           v-if="(isAdmin || isSectorManager) && user.pk !== currentUserPk && user.disabled" @click.prevent.stop="enableUser">
          <span class="icon"><i class="fas fa-check-circle"></i></span>
          <span>Activer utilisateur</span>
        </a>
        <a @click.prevent.stop="deleteUser" class="has-text-danger dropdown-item" slot="dropdown-content"
           v-if="(isAdmin || isSectorManager || isManager) && user.pk !== currentUserPk">
          <span class="icon"><i class="fas fa-trash-alt"></i></span>
          <span>Supprimer</span>
        </a>
      </sticky>
      <div
        class="columns is-padding-left-on-btn-actions is-padding-right-on-btn-actions has-stickyColumn has-stickyColumn--left js-user-vue-loaded"
        v-if="user" id="columns-collapse"> <!-- id=" user-vue-loaded columns-collapse" -->
        <div class="column is-4 is-3-fullhd is-paddingless-left is-paddingless-right">
          <div class="card has-bg-white is-bordered">
            <div class="is-padding-top is-padding-left is-padding-right is-padding-bottom-small has-text-centered">
              <figure class="image is-128x128 is-margin-auto has-picto">
                <div class="picto tooltip is-tooltip-right" data-tooltip="Editer la fiche" v-if="isAdmin || isManager || isMe">
                  <router-link :to="{name: 'UserEdit', params: {id: user.pk}}"
                    class="dot is-large has-bg-light-darken-3 has-text-white is-border is-border--white is-inline-block is-vcentered has-text-centered">
                    <div class="icon"><i class="fas fa-pen"></i></div>
                  </router-link>
                </div>
                <div class="is-border is-border-circle is-clipped">
                  <upload-file @upload="uploadAvatar" :documents="[user.picture]"
                               :is-avatar="true" :show-list="false" v-if="isAdmin || isMe"></upload-file>
                  <div v-else class="has-bg-light-darken-2 has-text-white is-clipped is-relative"
                       style="width:126px; height:126px; line-height:126px">
                    <img v-if="user.picture" :src="user.picture|avatarBig">
                    <i v-else class="is-absolutecenter fas fa-user-tie fa-6x"></i>
                  </div>
                </div>
              </figure>
              <div class="title is-3 is-margin-top-xsmall is-marginless-bottom">
                <b>{{user.first_name}} {{user.last_name}}</b>
              </div>
              <div class="is-size-5 has-text-weight-light" v-if="user.profil && user.profil.name && !isExternal">
                {{user.profil.name}}
                <span v-if="user.company_name">
                  chez <b>
                    <router-link
                      v-if="(isAdmin || isSectorManager || (isExternal && isManager))"
                      :to="{name: 'CompanyVue', params: {id: user.company.pk}}">{{user.company_name}}
                    </router-link>
                    <span v-else>{{user.company_name}}</span>
                  </b>
                </span>
              </div>
            </div>
            <div class="columns is-multiline" v-if="(isAdmin || isSectorManager || isManager) && !isMe">
              <div class="column is-12 columns is-column is-space-between">
                <div class="columns is-size-5 columns is-vcentered">
                  <div class="tags is-centered is-marginless column is-paddingless is-narrow">
                    <span v-if="user.disabled" class="tag is-danger is-uppercase is-marginless is-normal">
                      <i class="fas fa-user-lock is-padding-right-xsmall"></i> Désactivé
                    </span>
                    <span v-else-if="user.activated_on" class="tag is-success is-uppercase is-marginless is-normal">
                      <i class="fas fa-user-chart is-padding-right-xsmall"></i> Actif
                    </span>
                    <span v-else class="tag is-dark is-uppercase is-marginless is-normal">
                      <i class="fas fa-user-chart is-padding-right-xsmall"></i> Inactif
                    </span>
                    <!-- <span v-else>
                      <span v-else class="tag is-draft">En attente d'activation</span>
                    </span> -->
                  </div>
                  <div class="is-size-5 column is-margin-left-small is-paddingless">
                    <b>Dernière connexion :</b>
                    {{user.last_login_at|lastConnection}}
                  </div>
                </div>
              </div>
            </div>
            <div class="columns is-multiline is-border-top">
              <div class="column is-12 is-paddingless-bottom is-padding-top">
                <div class="columns is-gapless">
                  <div class="column is-size-6 is-narrow w80p is-margin-right-xsmall"><b>Mail :</b></div>
                  <div class="column is-size-6 is-break-word" v-if="user.email">
                    <a class="is-underline" :href="'mailto:'+user.email">{{user.email}}</a>
                  </div>
                </div>
              </div>
              <div class="column is-12 is-padding-top-xsmall">
                <div class="columns is-gapless">
                  <div class="column is-size-6 is-narrow w80p is-margin-right-xsmall"><b>Téléphone :</b></div>
                  <div class="column is-size-6">{{user.phone | prettyPhone}}
                  </div>
                </div>
              </div>
            </div>
            <div class="columns is-multiline is-border-top" v-if="(!user.is_admin && !user.is_sector_manager) && !isExternal">
              <div class="column is-12 columns is-column is-space-between">
                <div class="is-size-5">
                  <router-link :to="{name: 'UserVue', params: {id: user.referent}}"
                               v-if="user.referent_name && (isAdmin || isSectorManager || isOperator)">
                    <span><b>Administrateur référent : {{ user.referent_name }}</b></span>
                  </router-link>
                  <b v-else-if="user.referent_name">Administrateur référent : {{ user.referent_name }}</b>
                  <span v-else>Aucun administrateur référent <a v-if="!isSectorManager" @click="openReferentSelectionModal" class="is-underline">: Spécifier référent</a></span>
                </div>
              </div>
            </div>
            <div class="columns is-multiline is-border-top" v-if="user.is_seller && !isExternal">
              <div class="column is-12 columns is-column is-space-between">
                <div class="has-text-grey is-size-6">Manager</div>
                <div class="is-size-5">
                  <router-link :to="{name: 'UserVue', params: {id: user.manager}}"
                               v-if="user.manager_name && (isAdmin || isSectorManager || isManager || isSectorManager)">
                    <span><b>{{ user.manager_name }}</b></span>
                  </router-link>
                  <span v-else-if="user.manager_name && isSeller"><b>{{ user.manager_name }}</b></span>
                  <span v-else>Aucun manager <a @click="openManagerSelectionModal" v-if="!user.is_external" class="is-underline">: Spécifier manager</a></span>
                </div>
              </div>
            </div>
            <div class="columns is-multiline is-border-top" v-if="yearSalesStats"
                 :class="{'is-border-dashed':user.manager_name}">
              <div v-if="showSalesPanel"
                   class="column is-6 is-border-right is-border-dashed columns is-column is-space-between">
                <div class="has-text-grey is-size-6">Nombre de ventes</div>
                <a class="is-margin-top-xsmall is-size-4 has-text-weight-medium"
                   @click="showSalesPanel ? changePanel(PANELS.SALES) : null">{{yearSalesStats.salesCount}}</a>
              </div>
              <div v-if="showSalesPanel" class="column is-6 columns is-column is-space-between">
                <div class="has-text-grey is-size-6">Total ventes CA</div>
                <a class="is-margin-top-xsmall is-size-4 has-text-weight-medium"
                   @click="statsEnabled && showStatsPanel ? changePanel(PANELS.STATS) : null">{{yearSalesStats.CA |
                  prettyPrice}} {{$currency}}</a>
              </div>
              <div v-if="currentGoal && currentYear && currentYearCA"
                   class="column is-12 is-border-top is-border-dashed columns is-column is-space-between">
                <div class="has-text-grey is-size-6">Objectif CA {{currentYear}} : {{currentGoal.goal | prettyPrice }}
                  {{$currency}}
                </div>
                <div class="is-margin-top">
                  <progress class="progress is-success is-small" :value="goalProgress" max="100">{{goalProgress}}%
                  </progress>
                </div>
              </div>
              <div v-if="showSalesPanel"
                   class="column is-6 is-border-top is-border-right is-border-dashed columns is-column is-space-between">
                <div class="has-text-grey is-size-6">Options en cours</div>
                <a class="is-margin-top-xsmall is-size-4 has-text-weight-medium" @click="changePanel(PANELS.OPTIONS)">
                  <span v-if="options && runningOptions">{{runningOptions.length}}</span>
                  <span v-else>--</span>
                </a>
              </div>
              <div v-if="showRdvsPanel"
                   class="column is-6 is-border-top is-border-dashed columns is-column is-space-between">
                <div class="has-text-grey is-size-6" v-if="!user.is_external">Rdv à venir</div>
                <a class="is-margin-top-xsmall is-size-4 has-text-weight-medium" v-if="!user.is_external"
                   @click="changePanel(PANELS.RDV)">{{futurRdvCount}}</a>
              </div>
            </div>
          </div>
          <div v-if="(isAdmin || isSectorManager) && events && events.length > 0">
            <event-tracker-list :show-list="showLastEvents" :events="lastEvents"
                                :last-event="lastEvent"
                                :show-all="!!fullHistory && !!fullHistory.length"
                                @showAll="getFullHistory"
                                @toggle="showLastEvents = !showLastEvents">
            </event-tracker-list>
          </div>
        </div>
        <div class="column is-8 is-9-fullhd is-paddingless-right">
          <div v-if="hasPanels" class="has-bg-white is-border is-paddingless-bottom">
            <div class="tabs is-separatedUnderlined is-marginless-bottom is-radius-top-left is-radius-top-right">
              <ul class="has-text-weight-medium">
                <li v-if="statsEnabled && showStatsPanel" :class="{'is-active' : panel === 'UserStats'}">
                  <a @click="changePanel(PANELS.STATS)">Statistiques</a>
                </li>
                <li :class="{'is-active' : panel === 'UserTeam'}" v-if="user.is_manager">
                  <a @click="changePanel(PANELS.TEAM)">
                    <span v-if="currentUserPk === userId">Mon Équipe</span>
                    <span v-else>Équipe</span>
                  </a>
                </li>
                <li :class="{'is-active' : panel === 'UserSector'}" v-if="user.is_sector_manager">
                  <a @click="changePanel(PANELS.SECTOR)">
                    <span v-if="currentUserPk === userId">Mon secteur</span>
                    <span v-else>Secteur</span>
                  </a>
                </li>
                <li :class="{'is-active' : panel === 'LinkedUsersList'}" v-if="showLinkedUsersPanel">
                  <a @click="changePanel(PANELS.LINKEDUSERS)">Utilisateur(s) associé(s)</a>
                </li>
                <li v-if="showContactsPanel" :class="{'is-active' : panel === 'UserContact'}">
                  <a @click="changePanel(PANELS.CONTACTS)">Contacts</a>
                </li>
                <li v-if="showOptionsPanel" :class="{'is-active' : panel === 'UserOptions'}">
                  <a @click="changePanel(PANELS.OPTIONS)">Options</a>
                </li>
                <li v-if="showSalesPanel" :class="{'is-active' : panel === 'UserSales'}">
                  <a @click="changePanel(PANELS.SALES)">Ventes</a>
                </li>
                <li v-if="showRdvsPanel" :class="{'is-active' : panel === 'UserRdvs'}">
                  <a @click="changePanel(PANELS.RDV)">Rendez-vous</a>
                </li>
                <li v-if="showPolesPanel && (isAdmin || isSectorManager)" :class="{'is-active' : panel === 'UserPoles'}">
                  <a @click="changePanel(PANELS.POLES)">Pôle</a>
                </li>
              </ul>
            </div>
            <router-view :key="$route.name"
                         v-if="!loadingUsers"
                         :start-date="startDate"
                         :end-date="endDate"
                         :source-user="user"
                         :source-sellers="team"
                         :source-companies="companies"
                         :source-linked-users="linkedUsers"
                         :source-contacts="contacts"
                         :source-contacts-total="contactsTotal"
                         :source-options="options"
                         :source-author-options="authorOption"
                         :source-author-rdvs='allAuthorRdvs'
                         :sales="userSales"
                         :source-rdvs="userRdvs"
                         :source-poles="poles"
                         @addCompanies="getCompanies"
                         @updateOption="updateOption"
                         @deleteRdv="deleteRdv"
                         @deleteCompanies="getCompanies"
                         @updateSourceLinkedUsers="getLinkUsers"
                         @reloadSalesData="reloadSalesData">
            </router-view>
          </div>
          <user-charts-pane v-if="panel === 'UserStats' && sales && sortedSales && rdvs && !loadingUsers"
                            :key="$route.name"
                            :user="user"
                            :sales="sortedSales"
                            :entities="entities"
                            :rdvs="rdvs"
                            :start-date="startDate"
                            :end-date="endDate"
                            :team-count="sellers.length"
          ></user-charts-pane>

        </div>
      </div>
    </div>
  </div>
</template>

<script>
  import { mapState, mapGetters } from 'vuex'
  import moment from 'moment'
  // import { bus, EVENTS } from '@/services/bus/index.js'
  import { OptionStatus, DefaultValues, StatsMx, Error, EventTrackerMx } from '@/mixins'
  import { isNil, isEmpty } from 'lodash'
  import parallel from 'async/parallel'

  import UserContactList from './UserVuePanel/UserContactList'
  import UserOptionsList from './UserVuePanel/UserOptionsList'
  import UserPolesList from './UserVuePanel/UserPolesList'
  import UserRdvList from './UserVuePanel/UserRdvList'
  import UserStatsPane from './UserVuePanel/UserStatsPane'
  import UserChartsPane from './UserVuePanel/UserChartsPane'
  import UserTeamList from './UserVuePanel/UserTeamList'
  import UserSectorList from './UserVuePanel/UserSectorList'
  import LinkedUsersList from './UserVuePanel/LinkedUsersList'
  import UserSalesList from './UserVuePanel/UserSalesList'

  const PANELS = Object.freeze({
    CONTACTS: 'UserContact',
    OPTIONS: 'UserOptions',
    POLES: 'UserPoles',
    STATS: 'UserStats',
    RDV: 'UserRdvs',
    SECTOR: 'UserSector',
    TEAM: 'UserTeam',
    SALES: 'UserSales',
    LINKEDUSERS: 'LinkedUsersList'
  })

  // sellersDict : dictionnaire du vendeur courant et du groupe si manager ou a un manager correspondant à la periode de filtrage
  // sellers : listes contenant le vendeur courant et du groupe si manager ou a un manager correspondant à la periode de filtrage
  // team : liste des vendeurs du groupe si manager ou a un manager correspondant à la periode de filtrage
  // linkedUsers : liste des vendeurs référents à un admin

  // chaque seller possède une propriété _rdvs, _sales et _stats

  // sales : ventes du vendeur et du groupe si manager ou a un manager correspondant à la periode de filtrage
  // salesStats : donnée extraites de la liste des ventes
  // userSales : ventes du vendeur en cours correspondant à la période de filtrage
  // yearSales: toutes les ventes du vendeur sur l'année courante
  // yearSalesStats : stats des ventes du vendeur sur l'année courante

  // rdvs : rdvs du vendeur et du groupe si manager ou a un manager correspondant à la periode de filtrage
  // rdvsStats : donnée extraites de la liste des rdvs
  // userRdvs : rdvs du vendeur en cours correspondant à la période de filtrage
  // yearRdvs: tout les rdvs du vendeur sur l'année courante
  // yearRdvsStats : stats des rdvs du vendeur sur l'année courante
  // futureRdvs : tout les rdvs à venir du vendeur courant

  export default {
    name: 'UserVue',
    mixins: [OptionStatus, DefaultValues, StatsMx, Error, EventTrackerMx],
    components: {
      UserContactList,
      UserOptionsList,
      UserPolesList,
      UserRdvList,
      UserStatsPane,
      UserTeamList,
      UserSectorList,
      UserChartsPane,
      UserSalesList,
      LinkedUsersList
    },
    data () {
      return {
        returnId: null,
        allAuthorRdvs: [],
        authorOption: [],
        user: null,
        loading: true,
        routeMe: false,
        notifParams: {},
        PANELS: PANELS,
        sellersDict: {},
        options: [],
        companies: [],
        poles: [],
        contacts: [],
        contactsTotal: null,
        entityKey: 'USER',
        loadingStats: false,
        loadingUsers: false,
        startDate: null,
        endDate: null,
        sales: [],
        rdvs: [],
        stats: null,
        yearSales: [],
        yearRdvs: [],
        futureRdvs: [],
        linkedUsers: [],
        service: this.$api.userService
      }
    },
    filters: {
      lastConnection (val) {
        if (val) {
          let d = moment(val)
          return d.format('DD/MM [à] HH:mm')
        } else {
          return 'AUCUNE'
        }
      }
    },
    computed: {
      ...mapState(['currentUser', 'quickview']),
      ...mapGetters(['isAdmin', 'isManager', 'isSectorManager', 'currentUserPk', 'isExternal', 'isSeller', 'isOperator']),
      eventEntity () {
        return this.user
      },
      hasPanels () {
        return this.showContactsPanel || this.showStatsPanel || this.showOptionsPanel || this.showSalesPanel || this.showRdvsPanel || this.showPolesPanel || this.showLinkedUsersPanel
      },
      userAutority () {
        if (this.user) return (this.user.is_operator || this.user.is_manager || this.user.is_admin)
      },
      currentUserAutority () {
        if (this.currentUser) return (this.currentUser.is_admin || this.currentUser.is_operator || this.currentUser.is_manager)
      },
      showTeamsPanel () {
        if (this.user) return this.user.is_manager
      },
      showSectorPanel () {
        if (this.user) return this.user.is_sector_manager
      },
      showContactsPanel () {
        if (this.user) return this.user.is_seller || this.user.is_manager || this.user.is_admin || this.user.is_operator || this.user.is_sector_manager
      },
      showStatsPanel () {
        // return (this.user.is_seller || this.user.is_manager || this.user.is_admin) && this.isAdmin
        if (this.user) return !this.isExternal && !this.user.is_external
      },
      showOptionsPanel () {
        if (this.user) return this.user.is_seller || this.user.is_manager || this.user.is_admin || this.user.is_sector_manager
      },
      showSalesPanel () {
        if (this.user) return this.user.is_seller || this.user.is_manager || this.user.is_admin || this.user.is_sector_manager
      },
      showRdvsPanel () {
        if (this.user) return (this.user.is_operator || this.user.is_seller || this.user.is_manager || this.user.is_admin || this.user.is_sector_manager) && this.user.is_external === false
      },
      showPolesPanel () {
        if (this.user) return (this.user.is_seller || this.user.is_manager || this.user.is_admin || this.user.is_sector_manager) && (this.isAdmin || this.isSectorManager)
      },
      // showAllInformation () {
      //   return (this.currentUser.is_admin || this.currentUser.is_operator || this.currentUser.is_manager) && (this.user.is_operator || this.user.is_manager || this.user.is_admin)
      // },
      showLinkedUsersPanel () {
        if (this.user) return this.user.is_admin && this.isAdmin
      },
      runningOptions () {
        let running = []
        if (this.options && this.options.length) {
          running = this.options.filter(x => {
            return ['waiting_list', 'approved', 'pending'].includes(x.status)
          })
          if (this.authorOption && this.authorOption.length) {
            let allRunning = []
            let runningAuthor = this.authorOption.filter(x => {
              return ['waiting_list', 'approved', 'pending'].includes(x.status)
            })
            allRunning = runningAuthor.concat(running)
            return allRunning
          }
        }
        return running
      },
      entities () {
        let entities = []
        entities.push(this.userId)
        return entities
      },
      sellers () {
        return Object.values(this.sellersDict)
      },
      team () {
        if (this.sellers && this.sellers.length) {
          return this.sellers.filter(x => {
            return x.pk !== this.userId
          })
        }
        return []
      },
      userSales () {
        if (this.sales && this.sales.length) {
          return this.sales.filter(x => {
            return x.seller === this.userId
          })
        }
        return []
      },
      userRdvs () {
        if (this.rdvs && this.rdvs.length) {
          return this.rdvs.filter(x => {
            return x.seller === this.userId
          })
        }
        return []
      },
      salesStats () {
        if (this.sales) {
          return this.computedSalesData(this.sales)
        }
        return null
      },
      rdvsStats () {
        if (this.rdvs) {
          return this.computedRdvsData(this.rdvs)
        }
        return null
      },
      yearSalesStats () {
        if (this.yearSales) {
          return this.computedSalesData(this.yearSales)
        }
        return null
      },
      futurRdvCount () {
        if (this.futureRdvs) {
          const today = moment.utc()
          return this.futureRdvs.map(x => {
            let y = Object.assign({}, x)
            y._date = moment.utc(x.date)
            return y
          }).filter(x => x._date.diff(today) > 0).length
        }
        return null
      },
      currentYearCA () {
        if (this.yearSalesStats) {
          return this.yearSalesStats.CA
        }
        return null
      },
      goalProgress () {
        if (!isNil(this.currentGoal) && !isNil(this.currentYearCA)) {
          let progress = parseFloat(this.currentYearCA) / parseFloat(this.currentGoal.goal)
          progress = progress * 100
          progress = parseInt(progress)
          return progress
        }
        return null
      },
      currentYear () {
        return moment().format('YYYY')
      },
      currentGoal () {
        if (this.user && !isNil(this.user.goals)) {
          return this.user.goals.find(x => {
            return x.year.toString() === this.currentYear.toString()
          })
        }
        return null
      },
      statsEnabled () {
        if (this.$configs) return JSON.parse(this.$configs.STATS_ENABLED)
      },
      isMe () {
        return this.$route.params.id === 'me' || (this.user && this.currentUserPk === this.user.pk)
      },
      userId () {
        return this.$route.params.id === 'me' ? this.currentUserPk : this.$route.params.id
      },
      sortedSales () {
        let sales = []
        if (this.sales && this.sales.length) {
          this.sales.forEach(x => {
            let y = Object.assign({}, x)
            if (y.seller === this.userId) {
              sales.push(Object.assign({}, y))
            }
            if (this.sellers.length > 1) {
              y.seller_name = 'Moyenne du groupe'
              y.seller = '0000000000'
              sales.push(y)
            }
          })
        }
        return sales
      },
      panel () {
        return this.$route.name
      },
      events () {
        if (this.user) {
          return this.user.events
        } else {
          return []
        }
      }
    },
    watch: {
      '$route' (to, from) {
        if (to.params.id !== from.params.id) {
          this.initUser()
        }
      },
      quickview ({mode, params, results}) {
        if (results) {
          if (mode === 'MANAGE_NOTIFICATION') {
            this.notifParams.mail_alert = results.user.mail_alert
            this.notifParams.sms_alert = results.user.sms_alert
          } else if (mode === 'SELLER_SELECTION' && params.type === 'referent') {
            this.setReferent(results.entities[0])
          } else if (mode === 'SELLER_SELECTION' && params.type === 'manager') {
            this.setManager(results.entities[0])
          }
        }
      }
    },
    methods: {
      firstPanel () {
        if (this.statsEnabled && this.showStatsPanel) return this.changePanel(this.PANELS.STATS)
        else if (this.showTeamsPanel) return this.changePanel(this.PANELS.TEAM)
        else if (this.showSectorPanel) return this.changePanel(this.PANELS.SECTOR)
        else if (this.showLinkedUsersPanel) return this.changePanel(this.PANELS.LINKEDUSERS)
        else if (this.showContactsPanel) return this.changePanel(this.PANELS.CONTACTS)
        else if (this.showStatsPanel) return this.changePanel(this.PANELS.STATS)
        else if (this.showOptionsPanel) return this.changePanel(this.PANELS.OPTIONS)
        else if (this.showSalesPanel) return this.changePanel(this.PANELS.SALES)
        else if (this.showRdvsPanel) return this.changePanel(this.PANELS.RDV)
        else if (this.showPolesPanel) return this.changePanel(this.PANELS.POLES)
      },
      changePanel (panel) {
        this.$router.replace({name: panel})
        this.$router.replace({query: {returnId: this.returnId}})
      },
      initUser () {
        this.$set(this, 'authorOption', [])
        this.$set(this, 'allAuthorRdvs', [])
        this.$set(this, 'rdvs', [])
        this.$set(this, 'sales', [])
        this.$set(this, 'sellersDict', {})
        this.$set(this, 'stats', [])
        this.$set(this, 'futureRdvs', [])
        this.$set(this, 'yearRdvs', [])
        this.$set(this, 'yearSales', [])
        this.$set(this, 'linkedUsers', [])
        this.$set(this, 'user', null)
        if (this.$route.params.id === this.currentUserPk) {
          return this.$router.replace({name: 'UserVue', params: {id: 'me'}})
        }
        if (this.$route.params.id === 'me') {
          this.getMe()
          this.routeMe = true
        } else {
          this.getUser()
          this.routeMe = false
        }
      },
      getUser () {
        this.$api.userService.getOne(this.userId).then(res => {
          this.loading = false
          this.user = res.data
          this.notifParams.mail_alert = this.user.mail_alert
          this.notifParams.sms_alert = this.user.sms_alert
          this.init()
        }).catch(() => {
          this.loading = false
          this.$router.push({name: '404'})
        })
      },
      getMe () {
        this.$api.currentUserService.getOne().then(res => {
          this.loading = false
          this.user = res.data
          this.notifParams.mail_alert = this.user.mail_alert
          this.notifParams.sms_alert = this.user.sms_alert
          this.init()
        }).catch(() => {
          this.loading = false
          this.$router.push({name: '404'})
        })
      },
      init () {
        this.loadingUsers = true
        this.getPoles()
        this.$nextTick(() => {
          this.getOptions()
        })
        // this.getOptions()
        this.getContacts()
        this.loadUserStats()
        console.log(this.user)
        if (this.user.is_sector_manager) {
          this.getCompanies()
        }
        if (this.currentUserAutority && this.userAutority) {
          this.getAuthorRdv()
        }
        this.$set(this.sellersDict, this.user.pk, this.user)
        if (this.isAdmin && this.user.is_admin) {
          this.getLinkUsers()
        }

        let callbacks = []
        let fn0 = (callback) => {
          callback(null, [this.user.pk])
        }
        callbacks.push(fn0)

        let filters = null
        if (this.user.is_manager) {
          filters = {
            manager: this.user.pk
          }
        } else if (this.user.manager) {
          filters = {
            manager: this.user.manager
          }
          // si le user a un manager, on charge celui ci.
          let fn1 = (callback) => {
            this.$api.userService.getOne(this.user.manager).then(r => {
              this.$set(this.sellersDict, this.user.manager, r.data)
              callback(null, [this.user.manager])
            })
          }
          callbacks.push(fn1)
        }
        if (filters) {
          // si le user a un manager, ou est dans le groupe du manager, on charge les autres membres.
          let fn2 = (callback) => {
            this.$api.userService.get(filters).then(r => {
              r.data.items.forEach(s => {
                this.$set(this.sellersDict, s.pk, s)
              })
              let pks = r.data.items.map(x => x.pk)
              callback(null, pks)
            })
          }
          callbacks.push(fn2)
        }
        // res contiendra tout les pk des users chargés (manager, membre du groupe et user courant)
        parallel(callbacks, (err, res) => {
          if (err) {
            console.log(err)
          }

          // on recupere tout les array de pks pour en faire un tableau unique
          let pks = res.reduce((accum, sellers) => {
            return accum.concat(sellers)
          }, [])

          // on converti le tableau de pk en Set pour supprimer les doublons, on le re-transforme en tableau ensuite
          pks = Array.from(new Set(pks))
          // on utilises la liste des pk pour charger les stats concernants ces vendeurs
          this.loadUsersStats(pks)
          this.loadingUsers = false
        })
        if (this.$route.name === 'UserVue') {
          this.firstPanel()
        }
      },
      loadUsersStats (sellers) {
        this.loadingStats = true
        sellers.forEach(sellerPk => {
          this.$set(this.sellersDict[sellerPk], '_rdvs', [])
          this.$set(this.sellersDict[sellerPk], '_previousRdvs', [])
          this.$set(this.sellersDict[sellerPk], '_sales', [])
          this.$set(this.sellersDict[sellerPk], '_previousSales', [])
          this.$set(this.sellersDict[sellerPk], '_stats', {
            rdvs: null,
            previousRdvs: null,
            sales: null,
            previousSales: null
          })
        })

        let callbacks = []
        sellers.forEach(sellerPk => {
          let params = {
            startDate: this.startDate,
            endDate: this.endDate,
            entityKey: this.entityKey,
            entityPk: sellerPk
          }
          let fn1 = (callback) => {
            this.getEntitySalesStats(params).then(res => {
              let salesPk = this.sales.map(x => x.pk)
              let newSales = res.data.sales.filter(x => !salesPk.includes(x.pk))
              this.sales = this.sales.concat(newSales)
              this.$set(this.sellersDict[sellerPk], '_sales', res.data.sales)
              this.$set(this.sellersDict[sellerPk], '_previousSales', res.data.previous_sales)
              this.$set(this.sellersDict[sellerPk]._stats, 'sales', this.computedSalesData(res.data.sales))
              this.$set(this.sellersDict[sellerPk]._stats, 'previousSales', this.computedSalesData(res.data.previous_sales))
              callback(null, res.data)
            })
          }
          callbacks.push(fn1)

          let fn2 = (callback) => {
            this.getEntityRdvStats(params).then(res => {
              let rdvsPk = this.rdvs.map(x => x.pk)
              let newRdvs = res.data.rdvs.filter(x => !rdvsPk.includes(x.pk))
              this.rdvs = this.rdvs.concat(newRdvs)
              this.$set(this.sellersDict[sellerPk], '_rdvs', res.data.rdvs)
              this.$set(this.sellersDict[sellerPk], '_previousRdvs', res.data.previous_rdvs)
              this.$set(this.sellersDict[sellerPk]._stats, 'rdvs', this.computedRdvsData(res.data.rdvs))
              this.$set(this.sellersDict[sellerPk]._stats, 'previousRdvs', this.computedRdvsData(res.data.previous_rdvs))
              callback(null, res.data)
            })
          }
          callbacks.push(fn2)
        })

        parallel(callbacks, (err, res) => {
          if (err) {
            console.log(err)
          }
          this.loadingStats = true
        })
      },
      loadUserStats () {
        let params = {
          startDate: this.startDate,
          endDate: this.endDate,
          entityKey: this.entityKey,
          entityPk: this.userId
        }
        this.getEntitySalesStats(params).then(res => {
          this.yearSales = res.data.sales.filter(x => {
            return x.seller === this.userId
          })
        })
        this.getEntityRdvStats(params).then(res => {
          this.yearRdvs = res.data.rdvs.filter(x => {
            return x.seller === this.userId
          })
        })

        let params2 = {
          startDate: moment().utc(),
          endDate: moment('2100-01-01'),
          entityKey: this.entityKey,
          entityPk: this.userId,
          filters: {
            canceled: 0,
            deferred: 0
          }
        }
        this.getEntityRdvStats(params2).then(res => {
          let futureRdvsSeller = res.data.rdvs.filter(x => {
            return x.seller === this.userId
          })
          if (this.allAuthorRdvs && this.allAuthorRdvs.length) {
            let futureRdvsAuthor = this.allAuthorRdvs.filter(x => {
              if (x.seller !== this.userId) return x.author === this.userId
            })
            this.futureRdvs = futureRdvsSeller.concat(futureRdvsAuthor)
          } else {
            this.futureRdvs = futureRdvsSeller
          }
        })
      },
      inviteUser (email) {
        this.$api.userService.invite({email: email}, this.$configs.APPHOST).then(() => {
          this.$notify({
            type: 'is-success',
            text: `Un mail d'activation à été envoyé à l'adresse ${email}`
          })
        }).catch(() => {
          this.$notify({
            type: 'is-danger',
            text: `Erreur lors de l'envoi d'un mail d'activation à l'adresse ${email}`
          })
        })
      },
      patchUser ({data, successMessage, failMessage}, callback = () => {}) {
        this.$api.userService.patch(this.user.pk, data).then((res) => {
          this.$notify({
            type: 'is-success',
            text: successMessage || 'Modification enregistrées.'
          })
          this.user = res.data
          callback(res.data)
        }).catch(() => {
          this.$notify({
            type: 'is-danger',
            text: failMessage || 'Erreur lors de la modification'
          })
          callback(null)
        })
      },
      enableUser () {
        let data = {disabled: false}
        this.patchUser({
          data,
          successMessage: 'Compte activé',
          failMessage: 'Impossible d\'activer ce compte.'
        })
      },
      disableUser () {
        let data = {disabled: true}
        this.patchUser({
          data,
          successMessage: 'Compte désactivé',
          failMessage: 'Impossible de desactiver ce compte.'
        })
      },
      deleteUser () {
        this.$swal({
          title: 'Suppression',
          text: 'Êtes-vous sur de vouloir supprimer cet utilisateur ?',
          confirmButtonText: 'Supprimer'
        }).then(r => {
          if (r.value) {
            this.$api.userService.delete(this.user.pk).then(() => {
              this.$notify({
                type: 'is-warning',
                text: 'Utilisateur supprimé'
              })
              this.$router.replace({name: 'UserList'})
            }).catch(err => {
              this.handleError(err)
            })
          }
        })
      },
      manageNotifications () {
        this.$store.commit('setQuickview', {mode: 'MANAGE_NOTIFICATION', params: {source: this.notifParams}})
      },
      getLinkUsers () {
        this.$api.userService.get({referent: this.user.pk}).then(r => {
          this.linkedUsers = r.data.items
        })
      },
      getPoles () {
        this.poles = []
        if (this.user.poles && this.user.poles.length) {
          this.user.poles.forEach(p => {
            this.$api.poleService.getOne(p).then(r => {
              this.poles.push(r.data)
            })
          })
        }
      },
      getContacts () {
        this.$api.contactService.get({seller: this.userId, sort: 'last_name:asc'}).then(r => {
          this.contacts = r.data.items
          this.contactsTotal = r.data.total
        })
      },
      getOptions () {
        let id = this.$route.params.id !== 'me' ? this.$route.params.id : this.currentUserPk
        let query = {
          seller: id,
          status: ['waiting_list', 'approved', 'pending', 'refused', 'expired', 'canceled_by_admin', 'canceled_by_seller']
        }
        if (this.currentUserAutority && this.userAutority) {
          let query2 = {
            author: id,
            status: ['waiting_list', 'approved', 'pending', 'refused', 'expired', 'canceled_by_admin', 'canceled_by_seller']
          }
          this.$api.optionService.get(query2).then(res => {
            this.loading = false
            this.authorOption = res.data.items.filter(el => {
              if (!el.seller.includes(id) && el.author.includes(id)) {
                return el
              }
            })
          }).catch(err => {
            this.loading = false
            console.log(err)
          })
        }
        this.$api.optionService.get(query).then(r => {
          this.options = r.data.items
        })
      },
      getAuthorRdv () {
        let id = this.$route.params.id !== 'me' ? this.$route.params.id : this.currentUserPk
        let params = {
          author: id
        }
        this.$api.rdvService.get(params)
          .then(res => {
            this.allAuthorRdvs = res.data.items.filter(el => {
              if (!el.seller.includes(id) && el.author.includes(id)) {
                return el
              }
            })
          })
      },
      async getCompanies () {
        let id = this.$route.params.id !== 'me' ? this.$route.params.id : this.currentUserPk
        try {
          let { data } = await this.$api.axios.get(`users/${id}/companies`)
          this.companies = data
        } catch (err) {
          console.log(err)
        }
      },
      updateOption () {
        this.$nextTick(() => {
          this.getOptions()
        })
      },
      deleteRdv (id) {
        this.$swal({
          title: 'Suppression',
          text: 'Êtes-vous sur de vouloir supprimer ce rendez-vous ?',
          confirmButtonText: 'Supprimer'
        }).then(r => {
          if (r.value) {
            this.$api.rdvService.delete(id).then(r => {
              let idx = this.rdvs.findIndex(x => x.pk === id)
              this.rdvs.splice(idx, 1)
              this.$notify({
                text: 'Rendez-vous supprimé',
                type: 'is-success'
              })
            })
          }
        })
      },
      reloadSalesData (v) {
        if (!isEmpty(v)) {
          // this.startDate = moment(v.startDate)
          // this.endDate = moment(v.endDate)
          this.startDate = moment(v.startDate, 'YYYY-MM-DD')
          this.endDate = moment(v.endDate, 'YYYY-MM-DD')
          this.initUser()
        }
      },
      uploadAvatar (e) {
        this.user.picture = e[0]
        let data = {picture: e}
        this.patchUser({
          data,
          successMessage: 'Avatar mis à jour.',
          failMessage: 'Impossible de modifier l\'avatar.'
        }, (v) => {
          if (v && this.isMe) {
            this.$store.commit('patchCurrentUser', {picture: e[0]})
          }
        })
      },
      openReferentSelectionModal () {
        let params = {
          facets: { USER: ['is_admin:True'] },
          excludes: [this.user.pk],
          type: 'referent'
        }
        this.$store.commit('setQuickview', {mode: 'SELLER_SELECTION', params})
      },
      openManagerSelectionModal () {
        let params = {
          facets: { USER: ['is_manager:True', 'is_external:False'] },
          excludes: [this.user.pk],
          type: 'manager'
        }
        this.$store.commit('setQuickview', {mode: 'SELLER_SELECTION', params})
      },
      setReferent (referent) {
        console.log('setReferent')
        let data = {referent: referent.pk}
        this.patchUser({
          data,
          successMessage: 'Administrateur référent ajouté',
          failMessage: 'Impossible d\'ajouter l\'administrateur référent.'
        })
      },
      setManager (manager) {
        console.log('setManager')
        this.$api.groupService.post(manager.pk, {users: [this.user.pk]}).then(r => {
          this.user.manager_name = `${manager.last_name} ${manager.first_name}`
          this.user.manager = `${manager.pk}`
          this.$notify({
            type: 'is-success',
            text: 'Manager ajouter à l\'utilisateur'
          })
        }).catch(() => {
          this.$notify({
            type: 'is-danger',
            text: 'Impossible d\'ajouter le manager à l\'utilisateur'
          })
        })
      }
    },
    created () {
      this.startDate = moment().startOf('year')
      this.endDate = moment().endOf('year')
      if (this.$route.name === 'UserVue' && this.$route.query.returnId) this.returnId = this.$route.query.returnId
      this.initUser()
    }
  }
</script>



// WEBPACK FOOTER //
// src/components/users/UserVue.vue